import type { Usuario } from '../dados/fonte.js';
import { env } from './env.js';
import { db } from './local.js';
import { lerPerfil } from './perfil.js';
import { supabase } from './supabase.js';

/**
 * Quem esta usando o aparelho, para a fonte local.
 *
 * Com sessao: a linha de `person` ligada ao usuario (auth_uid), que chega pelo
 * sync. Sem essa linha ainda, o papel e o mais restrito — cadastro so depois de
 * o aparelho saber quem e a pessoa.
 *
 * Com o login desligado (dev ou build de previa): quem o "Ver como" escolher —
 * um avaliador deste aparelho, para testar o cadastro, ou um dono de haras, que
 * so consulta. Nada disso vai ao servidor: sem sessao nao ha sync.
 */
export async function usuarioLocal(): Promise<Usuario | null> {
  const { data } = await supabase.auth.getSession();
  const sessao = data.session;
  if (!sessao) {
    if (!env.semLogin) return null;
    return lerPerfil() === 'haras'
      ? { id: 'dono-deste-aparelho', nome: 'Proprietário do haras (este aparelho)', papel: 'haras' }
      : { id: 'avaliador-deste-aparelho', nome: 'Avaliador (este aparelho)', papel: 'avaliador' };
  }
  const pessoa = await db
    .table<Record<string, unknown>>('person')
    .filter((p) => p.auth_uid === sessao.user.id && !p.deleted_at)
    .first();
  if (!pessoa) return { id: sessao.user.id, nome: sessao.user.email ?? 'Usuário', papel: 'leitor' };
  return {
    id: String(pessoa.id),
    nome: String(pessoa.full_name ?? sessao.user.email ?? 'Usuário'),
    papel: (pessoa.app_role as Usuario['papel']) ?? 'leitor',
  };
}
